<template>
  <div class="form__section">
    <template v-if="toggleable">
      <component :is="`h${headerLevel}`" v-b-toggle:toggleable="'collapse_' + id" class="section-toggle">
        {{ sectionTitle }} <icons-caret class="b-icon" />
      </component>
      <b-collapse
        :id="'collapse_' + id"
        ref="collapse"
        :visible="visible || forceShow"
        :accordion="'collapse_' + id"
        @input="visible = $event"
      >
        <slot />
      </b-collapse>
    </template>
    <template v-else>
      <h2>{{ sectionTitle }}</h2>
      <slot />
    </template>
  </div>
</template>

<script>
import IconsCaret from "@/assets/icons/caret.svg";
export default {
  name: "FormSection",
  components: {IconsCaret},
  props: {
    sectionTitle: {
      type: String,
      required: true,
    },
    inititallyVisible: {
      type: Boolean,
      default: true,
    },
    toggleable: {
      type: Boolean,
      default: false,
    },
    forceShow: {
      type: Boolean,
      default: false,
    },
    headerLevel: {
      type: Number,
      default: 2,
    }
  },
  data() {
    return {
      id: null,
      // if route has hash, we keep everything uncollapsed
      // so we can scroll to the proper element.
      visible: this.inititallyVisible || !!this.$route.hash,
    };
  },
  mounted() {
    this.id = this._uid;
  },
  methods: {
    show() {
      this.visible = true;
    },
  },
};
</script>
<style scoped lang="scss">
.section-toggle {
  transition-duration: 0.5s;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 1.25rem 0;
  border-bottom: solid 1px $locomotion-grey;
  font-weight: 700;

  &.collapsed {
    margin-bottom: 0;
  }

  .b-icon {
    transition: 0.3s;
    transform: rotate(90deg);
    fill: $black;
  }

  &.not-collapsed .b-icon {
    transform: rotate(270deg);
  }
}
.form__section {
  border-bottom: none;
  margin-bottom: 0;
}
.collapse {
  background: white;
  padding: 30px;
  border-radius: 10px;
}
</style>
